export default "__VITE_ASSET__NBBaMZLt__"